export * from './load-detail.component';
